import React from 'react';
import { Helmet } from 'react-helmet-async';
import NavBar from '../components/Navbar';
import Footer from '../components/Footer';
import { generateWhatsAppLink } from '../utils/whatsapp';

const Revendedor = () => {
  const wpp = generateWhatsAppLink('revendedor', 'revendedor-page');
  return (
    <div>
      <Helmet>
        <title>Luminárias de LED para Revendedores | Sustenta LED</title>
        <meta name="description" content="Atacadista e distribuidora de LED para revendedores. Portfólio completo, suporte técnico e condições comerciais para parceiros." />
      </Helmet>
      <NavBar />
      <section className="section" style={{ paddingTop: '120px' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h1 style={{fontWeight: 900}}>Luminárias de LED para Revendedores</h1>
              <p>Somos atacadistas e distribuidores com foco em soluções para revendedores e lojistas. Oferecemos linhas completas com marcas homologadas, condições comerciais diferenciadas e suporte técnico para ampliar seu mix e margem.</p>
              <p>Atuamos com produtos para varejo e projetos, com assistência pré e pós-venda. Garantimos reposição, logística nacional e materiais de apoio para vendas.</p>
              <p>Seja um parceiro Sustenta LED e tenha atendimento especializado para compor sua oferta com qualidade e competitividade.</p>
              <div className="d-flex flex-column align-items-start">
                <a className="btn btn-success d-inline-flex align-items-center justify-content-center gap-2" href={wpp} target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-whatsapp" style={{ fontSize: '18px', lineHeight: 1 }}></i>
                  Solicite agora a sua cotação e receba em até 1h
                </a>
                <button type="button" className="btn btn-outline-secondary mt-2" onClick={() => window.history.back()}>
                  Voltar à página anterior
                </button>
              </div>
            </div>
            <div className="col-lg-6">
              <img src="/img/clientes/banner_revendedor.jpg" alt="Luminárias de LED para Revendedores - Sustenta LED" className="img-fluid rounded" />
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Revendedor;
